import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {geoUtils} from '../utils/geo-utils';

class UsaCountyHovers extends Component {

  shouldComponentUpdate(nextProps) {
    const widthDifferent = nextProps.width !== this.props.width;
    const heightDifferent = nextProps.height !== this.props.height;

    return widthDifferent || heightDifferent;
  }

  render() {
    const paths = geoUtils.getAlbersUsaCountyPaths(this.props.width, this.props.height);

    const getCountyMeta = county => {
      return {
        coords: county.center,
        stateFips: county.stateFips,
        countyFips: county.countyFips
      };
    };

    const getHandlers = county => {
      const onClick = this.props.onClick;
      const onHover = this.props.onHover;
      const handlers = {};

      if (onClick) {
        handlers.onClick = () => onClick(getCountyMeta(county));
      }

      if (onHover) {
        handlers.onMouseEnter = () => onHover(getCountyMeta(county));
        handlers.onMouseExit = () => onHover(null);
      }

      return handlers;
    };

    return (
      <g className="UsaCountyHovers">
        {paths.map(d => {
          return (
            <path
              key={d.id}
              id={`FIPS_${d.id}`}
              className="hover_out"
              d={d.path}
              {...getHandlers(d)}
            ></path>
          )
        })}
      </g>
    )
  }
}

UsaCountyHovers.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  onHover: PropTypes.func,
  onClick: PropTypes.func,
};

export default UsaCountyHovers


// WEBPACK FOOTER //
// ./src/charts/Map/UsaCountyHovers.js